import { redirect, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/quests')({
  beforeLoad: async ({ search, matches, location }) => {
    // only on exact match on this route, not the child
    if (matches.at(-1)?.id === Route.id) {
      throw redirect({
        to: '/quests/active-quests',
        search,
        state: {
          ...location.state,
          from: 'deeplink',
        },
      })
    }
  },
})
